import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetProfileDetailsRequest } from './getprofiledetailsrequest';

export class GetProfileDetailsAPI extends SixdeeCRBTAPI<GetProfileDetailsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-profile-details
        return "get-profile-details";
    }

    getRequestData()
    {
        return "clientTxnId=21042020"+"&"+
               "identifier=" + this.getRequest().getGetProfileDetailsRequest().getIdentifier() +"&"+
               "language="+ this.getRequest().getGetProfileDetailsRequest().getLanguage() +"&"+
               "msisdn=" + this.getRequest().getGetProfileDetailsRequest().getMsisdn();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/getprofiledetails/getprofiledetailsapi.tsx